import React, { useState, useEffect, useRef } from "react";
import "./lesson-assessment-question.css";
import { useNavigate } from "react-router-dom";
import ASSETS from "../../../../app/config/assets";
import Button from "../../../../ui/atoms/buttons/Button";
import { BsCheck2Circle, BsUiChecksGrid } from "react-icons/bs";
import { SlClose } from "react-icons/sl";
import { FaPercent, FaRegQuestionCircle } from "react-icons/fa";
import { GoClock } from "react-icons/go";
import AdmittedImg from "../../../../assets/images/admitted.svg";
import FailedImg from "../../../../assets/images/failed.svg";
import LessonAssessmentLeaderBoard from "../lesson-assessment-leaderborad/LessonAssessmentLeaderBoard";
//
import moment from "moment";
import Swal from "sweetalert2";
import {
  isEmpty,
  convertDuration,
  alphabet,
  shuffleArray,
} from "../../../../core/utils/helpers";
import { getMimeType } from "../../../../core/utils/common-validators";
//
import {
  onGetLessonAssessmentCurrentQuestion,
  onAnsweringLessonAssessmentCurrentQuestion,
} from "../../services/course";
import { useDispatch } from "react-redux";
import { challengeSlice } from "../../../../app/store/slices/challengeSlice";

const LessonAssessmentQuestion = ({
  assessmentId,
  assessmentMode,
  assessmentType,
  playerInvitationId,
  setQuestionTiming,
  setIsQuestionStarted,
  setIsQuestionStopped,
  setPointsGain,
  setTotalPoints,
  setActualQuestion,
  setTotalQuestions,
  responseTiming,
  currentTimerTiming,
  isSkipped,
  setIsSkipped,
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const isSelfPaced = assessmentMode?.toLowerCase() === "self-paced";
  const isVsStudents = assessmentMode?.toLowerCase() === "vs-students";
  const [view, setView] = useState("");
  //
  const [isFetching, setIsFetching] = useState(true); // True as initial value allow fetching the first question
  const [isStarted, setIsStarted] = useState(false); // false as initial value
  const [isRunning, setIsRunning] = useState(true); // Running for progress bar
  const [progress, setProgress] = useState(0); // Progress bar initial
  //
  const [scoresBoard, setScoresBoard] = useState([]); // scoresBoard/leaderboard
  //
  const [currentQuestion, setCurrentQuestion] = useState(); // current question
  const [shuffledAnswers, setShuffledAnswers] = useState([]);

  const [currentQuestionNumber, setCurrentQuestionNumber] = useState(0); // current question
  const [totalQuestionNumber, setTotalQuestionNumber] = useState(0); // current question
  const [isCurrentQuestionStoped, setIsCurrentQuestionStoped] = useState(false); // the current question is responded(stopped the timer)
  //
  const [expectedGoodAnswers, setExpectedGoodAnswers] = useState([]); // the defined good answers of the question
  const [clickedIndexes, setClickedIndexes] = useState([]); // the choosen index-answers by the student
  const [clickedAnswers, setClickedAnswers] = useState([]); // the choosen answers by the student

  const [isAssessCompleted, setIsAssessCompleted] = useState(false);

  const [_pointsWon, setPointsWon] = useState(0); // the points won after answering current question

  const hasMounted = useRef(false);

  useEffect(() => {
    let isMounted = true;
    const controller = new AbortController();
    const signal = controller.signal;

    if (isFetching) {
      const localData = {
        assessment_id: assessmentId,
        assessment_invitation_id: playerInvitationId,
        assessment_mode: assessmentMode,
      };
      onGetLessonAssessmentCurrentQuestion(localData, signal)
        .then((response) => {
          console.log({ "TEST LA": response });
          const _data = response?.data?.result;
          const _is_completed = _data?.is_completed;
          const question = _data?.current_question;
          setCurrentQuestion(question);
          setIsAssessCompleted(_is_completed);
          setScoresBoard({
            scores: _data?.scoreboard,
            report: _data?.report,
            total_questions: _data?.total_questions,
          });
          if (isSelfPaced && !_is_completed) {
            setView("preload");
          }
          if (isVsStudents) {
            setView("scoreboard");
          }
          //
          const _answers = Array.from(question?.answers, (item, idx) => ({
            id: idx,
            answer: item?.answer,
            is_correct: item?.is_correct,
          }));

          // setup correct answers
          const correctAnswers = _answers?.filter(
            (item) => item.is_correct === true,
          );
          //
          setExpectedGoodAnswers(correctAnswers);
          setShuffledAnswers(shuffleArray(_answers));
          //
          if (question?.timing && typeof setQuestionTiming === "function") {
            setQuestionTiming(parseInt(question?.timing));
            setPointsGain(_data?.total_points_won);
            setTotalPoints(_data?.assessment_total_points);
            setActualQuestion(_data?.current_question_number);
            setTotalQuestions(_data?.total_questions);
            setCurrentQuestionNumber(_data?.current_question_number);
            setTotalQuestionNumber(_data?.total_questions);
          }
          setIsFetching(false);
        })
        .catch((error) => {
          if (error?.response?.status === 500) {
            Swal.fire({
              icon: "error",
              title: "Error",
              text: "Internal Server Error. Please try again later.",
            });
          } else {
            Swal.fire({
              icon: "error",
              title: "Error",
              text: error?.response?.data?.detail?.message,
            });
          }
        });
    }
    return () => {
      isMounted = false;
      isMounted && controller.abort();
    };
  }, [isFetching]);

  useEffect(() => {
    if (isCurrentQuestionStoped && responseTiming === 0) {
      setIsStarted(false);
      setProgress(0);
      setIsRunning(true);
    }
  }, [isCurrentQuestionStoped]);

  // on timer over
  useEffect(() => {
    if (view === "preload" && !isAssessCompleted) {
      if (progress < 100 && isRunning) {
        setTimeout(() => setProgress((prev) => (prev += 2)), 50);
      }
      if (progress === 100) {
        setView("question");
        setIsStarted(true);
        setIsQuestionStarted(true);
        setIsRunning(false);
      }
    }
  }, [progress, isRunning, view]);

  const totalAnswers = expectedGoodAnswers?.length;

  useEffect(() => {
    if (currentTimerTiming === 0) {
      const val = Math.abs(
        expectedGoodAnswers?.length - clickedIndexes?.length,
      );
      for (let i = 0; i < val; i++) {
        setClickedIndexes((prev) => [...prev, expectedGoodAnswers?.length + 1]);
        setClickedAnswers((prev) => [
          ...prev,
          {
            answer: "is skipped",
            is_correct: false,
          },
        ]);
      }
    }
  }, [currentTimerTiming]);

  // on skipped question by user
  useEffect(() => {
    if (isSkipped) {
      setClickedIndexes([]);
      setClickedAnswers([]);
      //
      for (let i = 0; i < expectedGoodAnswers?.length; i++) {
        setClickedIndexes((prev) => [...prev, expectedGoodAnswers?.length + 1]);
        setClickedAnswers((prev) => [
          ...prev,
          {
            answer: "is skipped",
            is_correct: false,
          },
        ]);
      }
    }
  }, [isSkipped]);

  // on user answered
  useEffect(() => {
    if (!hasMounted.current) {
      hasMounted.current = true;
      return; // ignore la première exécution
    }

    if (clickedIndexes.length === totalAnswers && totalAnswers > 0) {
      setIsQuestionStopped(true);
      //
      const _local_details_id = currentQuestion?.details_id;
      const _timing = Math.abs(
        parseInt(currentQuestion?.timing) - parseInt(currentTimerTiming),
      );
      //
      // Function to count correct answers from 'answers' that match with 'data'
      const countCorrectMatches = () => {
        return clickedAnswers.filter((ans) => {
          return (
            ans.is_correct === true &&
            expectedGoodAnswers.some(
              (d) => d.answer === ans.answer && d.is_correct === true,
            )
          );
        }).length;
      };
      //
      const _points = Math.round(
        (currentQuestion?.points / totalAnswers) * countCorrectMatches(),
      );
      setPointsWon(_points);
      //
      const localData = {
        details_id: _local_details_id,
        answers: JSON.stringify(clickedAnswers),
        timing: _timing,
        points: _points,
        assessment_invitation_id: playerInvitationId,
      };
      onAnsweringLessonAssessmentCurrentQuestion(localData);
    }
  }, [clickedIndexes, totalAnswers]);

  useEffect(() => {}, [scoresBoard]);

  const onAnswer = (id) => {
    if (clickedIndexes.length === totalAnswers && totalAnswers > 0) return;
    if (clickedIndexes.includes(id)) return;
    setClickedIndexes((prev) => [...prev, id]);
    setClickedAnswers((prev) => [
      ...prev,
      {
        id: shuffledAnswers[id]?.id,
        answer: shuffledAnswers[id]?.answer,
        is_correct: shuffledAnswers[id]?.is_correct,
      },
    ]);
  };

  const onHandleLogout = async () => {
    dispatch(
      challengeSlice?.actions?.setCurrentAssessment({
        mode: null,
        admission_test_id: null,
        challenge_id: null,
        challenge_type: null,
        teams_breakdown: null,
        teams_device: null,
        request_id: null,
      }),
    );
    navigate("/signin", { replace: true });
  };

  return (
    <div className="challenge-questions">
      {!isEmpty(currentQuestion) && view === "question" && (
        <React.Fragment>
          <div className="ch-q-container mb-md">
            <div className="ruban">
              <img
                src={ASSETS?.icon_question_png}
                alt="icon illustartion of question explanation"
                className="tick-img"
              />
              <span>Question Type :</span>
              <span style={{ color: "brown", paddingLeft: "1rem" }}>
                <i>
                  <em>
                    {totalAnswers > 1
                      ? "Multiple Choice Answers"
                      : "Single Choice Answer"}
                  </em>
                </i>
              </span>
              <span style={{ padding: "0 1rem" }}>
                <i>
                  <em>for</em>
                </i>
              </span>
              <span style={{ color: "green" }}>
                <i>
                  <em>{currentQuestion?.points} point.</em>
                </i>
              </span>
            </div>
            {/* Question section */}
            <div className="w-full d-flex align-center ch-q-wrapper pt-xs">
              <div
                className="ch-q-description"
                style={{
                  width:
                    isEmpty(currentQuestion?.cover_audio) &&
                    isEmpty(currentQuestion?.cover_image) &&
                    "100% !important",
                }}
              >
                <div
                  className="ql-editor"
                  style={{ height: "auto" }}
                  dangerouslySetInnerHTML={{
                    __html: currentQuestion?.description,
                  }}
                />
              </div>
              <div
                className="ch-q-assets"
                style={{
                  display:
                    isEmpty(currentQuestion?.cover_audio) &&
                    isEmpty(currentQuestion?.cover_image) &&
                    "none !important",
                }}
              >
                {currentQuestion?.cover_audio && (
                  <div className="asset-audio">
                    <audio
                      className="w-full"
                      controls
                      controlsList="nodownload"
                      onContextMenu={(e) => e.preventDefault()}
                    >
                      <source
                        src={`${process.env.REACT_APP_API_SERVER_URL}:${process.env.REACT_APP_API_SERVER_PORT}/storage/audios/lessons/${currentQuestion?.cover_audio}`}
                        type={getMimeType(currentQuestion?.cover_audio?.type)}
                      />
                    </audio>
                  </div>
                )}
                {currentQuestion?.cover_image && (
                  <div className="asset-img" style={{ textAlign: "center" }}>
                    <img
                      src={`${process.env.REACT_APP_API_SERVER_URL}:${process.env.REACT_APP_API_SERVER_PORT}/storage/images/lessons/${currentQuestion?.cover_image}`}
                      alt="cover question illustration"
                      style={{ maxWidth: "100%" }}
                      onContextMenu={(e) => e.preventDefault()}
                    />
                  </div>
                )}
              </div>
            </div>
            {/* end Question section */}
          </div>
          <div className="answers-container mb-md">
            {shuffledAnswers?.map((answer, idx) => {
              const wasClicked = clickedIndexes.includes(answer?.id);
              const isCorrect = answer.is_correct;

              return (
                <div
                  className={
                    wasClicked
                      ? isCorrect
                        ? "answer-item is-good is-selected"
                        : "answer-item is-wrong is-selected"
                      : "answer-item"
                  }
                  key={answer?.id}
                  onClick={() =>
                    !isCurrentQuestionStoped && onAnswer(answer?.id)
                  }
                >
                  <div className="answer-item-head">
                    <span className="number-label">
                      {alphabet[idx]?.[idx + 1]}
                    </span>
                    {wasClicked &&
                      (isCorrect ? (
                        <BsCheck2Circle className="icon" />
                      ) : (
                        <SlClose className="icon" />
                      ))}
                    <span>
                      {wasClicked
                        ? isCorrect
                          ? "Correct Answer"
                          : "Wrong Answer"
                        : ""}
                    </span>
                  </div>
                  <div
                    className="ql-editor"
                    style={{ height: "auto" }}
                    dangerouslySetInnerHTML={{
                      __html: answer?.answer,
                    }}
                  />
                </div>
              );
            })}
          </div>
          {clickedIndexes?.length === expectedGoodAnswers?.length && (
            <>
              <div className="ch-q-container mb-md fade-in">
                <div className="ruban">
                  <img
                    src={ASSETS?.icon_brain_light_gif}
                    alt="icon illustartion of question explanation"
                    className="tick-img"
                  />
                  <span>Explanations</span>
                </div>
                <div
                  className="ql-editor"
                  style={{ height: "auto" }}
                  dangerouslySetInnerHTML={{
                    __html: currentQuestion?.explanations,
                  }}
                />
              </div>
              <div className="ch-q-container mb-md fade-in">
                <div className="ruban">
                  <img
                    src={ASSETS?.icon_success_gif}
                    alt="icon illustartion of question explanation"
                    className="tick-img"
                  />
                  <span>Correction</span>
                </div>
                <div className="answers-container p-xs">
                  {expectedGoodAnswers?.map((answer, idx) => {
                    return (
                      <div className={"answer-item is-good"} key={idx}>
                        {answer?.is_correct ? (
                          <span>
                            <BsCheck2Circle className="icon" />
                          </span>
                        ) : (
                          <span>
                            <SlClose className="icon" />
                          </span>
                        )}
                        <div
                          className="ql-editor"
                          style={{ height: "auto" }}
                          dangerouslySetInnerHTML={{
                            __html: answer?.answer,
                          }}
                        />
                      </div>
                    );
                  })}
                </div>
                <div className="w-full d-flex flex-col align-center justify-center p-md">
                  <p>
                    Total points won :{" "}
                    <i>
                      <em>{_pointsWon} points.</em>
                    </i>
                  </p>
                  <Button
                    type={"button"}
                    preferedStyle={"normal"}
                    title={"Got It, Go to Next question!"}
                    action={() => {
                      setExpectedGoodAnswers([]);
                      setClickedIndexes([]);
                      setClickedAnswers([]);
                      setQuestionTiming(0);
                      setIsCurrentQuestionStoped(false);
                      setProgress(0);
                      setIsRunning(true);
                      setIsStarted(false);
                      setIsQuestionStopped(false);
                      setIsQuestionStarted(false);
                      setIsSkipped(false);
                      setIsFetching(true);

                      if (isSelfPaced) {
                        setView("preload");
                      }
                      if (isVsStudents) {
                        setView("scoreboard");
                      }
                    }}
                  />
                </div>
              </div>
            </>
          )}
        </React.Fragment>
      )}
      {/* Preload Question View */}
      <div
        className={
          view === "preload"
            ? "question-preloader slide-in"
            : "question-preloader slide-out"
        }
      >
        <div className="question-preloader-wrapper">
          <BsUiChecksGrid className="preview-icon" />
          <span className="preview-count">
            {currentQuestionNumber} of {totalQuestionNumber}
          </span>
          <div className="preview-question">
            <div
              className="ql-editor"
              style={{ height: "auto" }}
              dangerouslySetInnerHTML={{
                __html: currentQuestion?.description,
              }}
            />
          </div>
          <div className="preview-progress">
            <div
              className="progress-bar"
              style={{ width: `${progress}%` }}
            ></div>
          </div>
        </div>
      </div>
      {/* Self-Paced Report View */}
      <div
        className={
          isSelfPaced && isAssessCompleted
            ? "admission-report slide-in"
            : "admission-report slide-out"
        }
      >
        <div className="admission-report-wrapper">
          {(
            (currentQuestion?.current_gained_points /
              currentQuestion?.total_points) *
            100
          ).toFixed(2) >= 50 ? (
            <img
              src={AdmittedImg}
              alt="success illustration"
              className="a-t-img"
            />
          ) : (
            <img
              src={FailedImg}
              alt="failed illustration"
              className="a-t-img"
            />
          )}
          {(
            (currentQuestion?.current_gained_points /
              currentQuestion?.total_points) *
            100
          ).toFixed(2) >= 50 ? (
            <h1>Well done! You succeed the AT and you are admitted.</h1>
          ) : (
            <h1>
              Sorry! You miss the AT with a score wich is not enough to get
              Admitted to the stream you wish.
            </h1>
          )}
          <div className="ad-rep-ruban">
            <div className="ad-rep-ruban-tile">
              <FaPercent className="icon" />
              <div className="col">
                <span>Success rate</span>
                <h1>
                  {(
                    (currentQuestion?.current_gained_points /
                      currentQuestion?.total_points) *
                    100
                  ).toFixed(2)}
                  %
                </h1>
              </div>
            </div>
            <div className="ad-rep-ruban-tile">
              <FaRegQuestionCircle className="icon" />
              <div className="col">
                <span>Total Questions</span>
                <h1>{currentQuestion?.questions?.length}</h1>
              </div>
            </div>
            <div className="ad-rep-ruban-tile">
              <GoClock className="icon" />
              <div className="col">
                <span>Duration</span>
                <h1>{convertDuration(currentQuestion?.duration)}</h1>
              </div>
            </div>
            <div className="ad-rep-ruban-tile">
              <FaRegQuestionCircle className="icon" />
              <div className="col">
                <span>Total Success Questions</span>
                <h1>{currentQuestion?.success_questions}</h1>
              </div>
            </div>
            <div className="ad-rep-ruban-tile">
              <FaRegQuestionCircle className="icon" />
              <div className="col">
                <span>Total Missed Questions</span>
                <h1>{currentQuestion?.failed_questions}</h1>
              </div>
            </div>
          </div>
          <div className="ad-rep-questions">
            {currentQuestion?.questions?.map((row, idx) => {
              return (
                <div className="ad-rep-question-item" key={idx}>
                  <div className="row">
                    <span>Question {idx + 1}</span>
                    <span>
                      {row?.type === "OCA"
                        ? "Single Choice Answer"
                        : "Multiple Choice Answers"}
                    </span>
                    <span>
                      {row?.question_won_points} points earned over{" "}
                      {row?.question_total_points} Points
                    </span>
                  </div>
                  <p
                    dangerouslySetInnerHTML={{
                      __html: row?.description,
                    }}
                  />
                  <div className="row-tick">
                    <span className="tick-label">Explanations</span>
                  </div>
                  <p
                    dangerouslySetInnerHTML={{
                      __html: row?.explanations,
                    }}
                  />
                  <div className="row-tick">
                    <span className="tick-label">
                      Initials and Expected reponses
                    </span>
                  </div>
                  <div className="responses-wrapper">
                    {row?.initial_answers?.map((element, j) => {
                      return (
                        <div
                          className={`response-item ${
                            element?.is_correct ? "is-good" : "is-wrong"
                          }`}
                          key={j}
                        >
                          {element?.is_correct ? (
                            <BsCheck2Circle className="icon" />
                          ) : (
                            <SlClose className="icon" />
                          )}
                          <p
                            dangerouslySetInnerHTML={{
                              __html: element?.answer,
                            }}
                          />
                        </div>
                      );
                    })}
                  </div>
                  <div className="row-tick">
                    <span className="tick-label">Your reponses</span>
                  </div>
                  <div className="responses-wrapper">
                    {row?.responded_answers?.map((el, k) => {
                      return (
                        <div
                          className={`response-item ${
                            el?.is_correct ? "is-good" : "is-wrong"
                          }`}
                          key={k}
                        >
                          {el?.is_correct ? (
                            <BsCheck2Circle className="icon" />
                          ) : (
                            <SlClose className="icon" />
                          )}
                          <p
                            dangerouslySetInnerHTML={{
                              __html: el?.answer,
                            }}
                          />
                        </div>
                      );
                    })}
                  </div>
                </div>
              );
            })}
          </div>
          <div className="p-md">
            <Button
              type={"button"}
              preferedStyle={"default"}
              title={"Close Admission Test Report and Sign In again!"}
              action={() => onHandleLogout()}
            />
          </div>
        </div>
      </div>
      {/* Preview ScoresBoard */}
      <div
        className={
          view === "scoreboard"
            ? "question-preloader slide-in"
            : "question-preloader slide-out"
        }
      >
        <LessonAssessmentLeaderBoard
          is_completed={isAssessCompleted}
          data={scoresBoard}
          assessment_Mode={assessmentMode}
          setView={setView}
        />
      </div>
    </div>
  );
};

export default LessonAssessmentQuestion;
